import { CountryCode } from '../enums/CountryCode';

interface FormatTelOptions {
  countryCode: string;
  number: string;
}

const LEADING_ZERO_REGEX = /^0{1}/;
const TWO_LEADING_ZEROS_REGEX = /^0{2}/;

export const formatTel = ({ countryCode, number }: FormatTelOptions) => {
  const twoLeadingZerosMatches = TWO_LEADING_ZEROS_REGEX.exec(number);

  if (twoLeadingZerosMatches) {
    const matchingCountryCode = `+${number.substring(2, 4)}` as CountryCode;

    if (Object.values(CountryCode).includes(matchingCountryCode)) {
      return `+${number.substring(2)}`;
    }
  }

  const numberWithoutLeadingZero =
    countryCode === CountryCode.Italy ? number : number.replace(LEADING_ZERO_REGEX, '');

  return countryCode + numberWithoutLeadingZero;
};
